export default __webpack_public_path__ + "public/assets/images/4f13be433464a06356535e879efe87c3.png";